import { Loader } from '@alfa-retail-react/components';
import React from 'react';

const loaderElement = <Loader show fillWindow />;
const loaderCSS = `
<style>
:root {
    --spinner-display-visible: inline-block;
    --spinner-animation-duration: 0.8s;
    --spinner-animation-timing-function: linear;
}

body {
    background: rgba(243, 244, 245, 1);
}

.alfaLoader {
    position: relative;
    width: fit-content;
}

.alfaLoader.fill-window {
    position: fixed;
    left: calc(50% - 30px);
    top: calc(50% - 30px);
    width: 60px;
    height: 60px;
    z-index: 9999;
}

.alfaLoader.spinner {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    color: white;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    z-index: 9999;
}

.alfaLoader.spinner .spinner-container {
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
}

.spinner {
    animation: spin_animation var(--spinner-animation-duration) infinite
        var(--spinner-animation-timing-function);
}

@keyframes spin_animation {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

</style>
`;

export const rawHTMLLoader = {
    element: loaderElement,
    style: loaderCSS,
};
